// Cart drawer enhancements: copy-code button for the offer banner.
// Uses delegated events on document since the drawer's inner HTML is
// replaced wholesale on every AJAX cart update (innerHTML swaps don't
// re-run inline scripts, so listeners bound directly to the button
// would be lost after the first cart change).
document.addEventListener('click', function (event) {
  const button = event.target.closest('.cart-drawer__offer-banner-copy');
  if (!button) return;

  const code = button.getAttribute('data-code');
  if (!code) return;

  navigator.clipboard
    .writeText(code)
    .then(function () {
      const originalText = button.textContent;
      button.textContent = 'Copied';
      button.classList.add('copied');
      setTimeout(function () {
        button.textContent = originalText;
        button.classList.remove('copied');
      }, 2000);
    })
    .catch(function (err) {
      console.error('Failed to copy code:', err);
    });
});

// Promo slider: initialize Swiper on the cart drawer's slide banner.
// The drawer's inner HTML is replaced wholesale on every AJAX cart update,
// which destroys any existing Swiper instance along with its DOM, so we
// watch for new, not-yet-initialized sliders and (re)initialize them
// instead of relying on a one-time DOMContentLoaded init.
function initCartDrawerSliders() {
  if (typeof Swiper === 'undefined') return;
  document.querySelectorAll('.cart-drawer__slider:not([data-swiper-initialized])').forEach(function (el) {
    el.setAttribute('data-swiper-initialized', 'true');
    new Swiper(el, {
      loop: el.querySelectorAll('.swiper-slide').length > 1,
      autoplay: el.querySelectorAll('.swiper-slide').length > 1 ? { delay: 5000, disableOnInteraction: false } : false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

initCartDrawerSliders();

const cartDrawerEl = document.getElementById('CartDrawer');
if (cartDrawerEl && window.MutationObserver) {
  new MutationObserver(initCartDrawerSliders).observe(cartDrawerEl, {
    childList: true,
    subtree: true,
  });
}
